import { MARKS } from '@contentful/rich-text-types';
/**
 * Builds a string of classes based on the marks array of a contentful rich text node
 * to determine if the text should be bold, italic, etc.
 * @param {*} item
 * @returns {string} Returns a string of classes
 */
const marksClassBuilder = (item) => {
  let marksClass = '';

  if (item.marks.length > 0) {
    item.marks.forEach((mark, index) => {
      switch (mark.type) {
        case MARKS.BOLD:
          marksClass += 'font-weight-bold';
          break;
        case MARKS.ITALIC:
          marksClass += 'font-italic';
          break;
        default:
          break;
      }
      if (index < item.marks.length - 1) {
        marksClass += ' ';
      }
    });
  }

  return marksClass;
};

export default marksClassBuilder;
